module.exports = __webpack_public_path__ + "img/aion.a52514a3.svg";